import React, { useState, useEffect } from "react"
import appropriationsService from '../../services/appropriation';
import ScrollableTable from '../DataGrid/DataGrid';

import './ModalAppropriations.scss';

import editIcon from '../../assets/edit-icon.png';
// import deleteIcon from '../../assets/delete-icon.png';

function ModalAppropriations({onCloseModal, appropriationData}) {
  const [appropriations, setAppropriations] = useState([]);
  const [deleteSup, setDelete] = useState(0);

  const TableHeaders = [{
    Header: '-',
    columns: [
      {
          Header: 'Apropriação',
          accessor: 'appropriation',
          textAlign: 'left',
          width: 220,
      },
      {
        Header: 'Ações',
        accessor: 'action',
        textAlign: 'left',
        width: 120,
      }
    ]
  }];

  const rows = appropriations.map((value, index) => {
    return {
      appropriation: value.name,
      action: (<>
        {/* <button style={{ float: 'right' }} onClick={() => setDelete(1)}><img src={deleteIcon} style={{ width: '18px', height: '18px' }} /></button> */}
        <button style={{ float: 'right' }} onClick={() => appropriationData(appropriations[index])}><img src={editIcon} alt="Editar Fornecedor" style={{ width: '18px', height: '18px' }} /></button>
      </>),
      key: index,
    }
  });

  useEffect(() => {
    const getAppropriations = async () => {
      try {
        const appropriation = await appropriationsService.getAll();
        setAppropriations(appropriation.data);
      } catch (error) {
        console.error('Error fetching expenses:', error);
      }
    };

    getAppropriations();
  }, []);

  return (
    <>
      <div className='modal-companies'>
        <div className="inner-content">
          {!deleteSup ? (
            <>
              <button className="btn-close" onClick={() => onCloseModal(false)}>X</button>
              <h3>Apropriações Cadastradas</h3>
              {rows.length > 0 ? (
                <ScrollableTable headers={TableHeaders} height={'60vh'} dataRows={rows} />
              ) : (
                <p>Carregando...</p>
              )}
            </>
          ) : (
            <>
              <div className="wrapper-delete">
                <h3>Excluir Apropriação?</h3>
                <button className={'btn--primary'}>Sim</button>
                <button className={'btn--primary'} onClick={() => setDelete(0)}>Não</button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default ModalAppropriations;
